import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';

export class OnboardingJurisdictionCompletedEventTracking extends SelfServeSignupPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_JURISDICTION_COMPLETED;
  jurisdiction?: string;

  constructor(eventProperties: Partial<OnboardingJurisdictionCompletedEventTracking> = {}) {
    super(eventProperties);
    this.jurisdiction = eventProperties?.jurisdiction;
  }
}
